import { Component } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { MarketplaceBillingInformationState } from '@platform-frontend/marketplace';
import { Observable } from 'rxjs';
import { CHECKOUT_TRANSLOCO_SCOPE } from '../../checkout-transloco-scope';

@Component({
  selector: 'yat-accounting-email',
  templateUrl: './accounting-email.component.html',
  styleUrls: ['./accounting-email.component.scss'],
  providers: [provideTranslocoScope(CHECKOUT_TRANSLOCO_SCOPE)]
})
export class AccountingEmailComponent {
  constructor(private store: Store) {}

  accountingEmail$: Observable<string | null> = this.store.select(MarketplaceBillingInformationState.accountingEmail);
}
